import { ADD_EXCEPTION, CLEAR_EXCEPTION } from '../../constants/index.js';

/**
 * Fetch result error reducer.
 * 
 * @param  {Array}  state  The initial state.
 * @param  {String} action The action to perform. 
 * @return {Object}
 */
export default function ( state = [], action )
{
	switch ( action.type )
	{
		case ADD_EXCEPTION:
			return [ ...state, action.payload ];

		case CLEAR_EXCEPTION:
			return [];
		
		default:
			return [ ...state ];
	}
}